import {scrollToTarget} from './scrollToTarget';

function delegateEvent(el, event, selector, callback) {
    el.addEventListener( event, (e) => {
        if (e.target && e.target.closest(selector)) {
            (callback && typeof callback === 'function') && callback(e);
        }
    });
}

export {
    delegateEvent,
    scrollToTarget,
};
